<template>
  <div>
    <!-- 范围-选择 -->
    <date-range
      v-if="formateRangeDatasStatus"
      :title="rangeTitTxt"
      range
      type="follow"
      @memberChange="handleCascaderSubmit"
    />
    <!-- 概览-选择 -->
    <date-range
      :title="overviewTitTxt"
      :date-data="dateData"
      @dateCallback="handleDateChange($event,0)"
    />
    <!-- 概览-数据 -->
    <div class="dev-overview-div">
      <div
        v-for="(item,index) in listDatas"
        :key="index"
        class="dev-normal-content clearfix"
      >
        <span class="text large-text">{{ item.name }}</span><span class="number">{{ item.num }}</span>
      </div>
    </div>
    <!-- 数据-选择 -->
    <date-range
      :title="dataTitTxt"
      group
      :groupname="defaultTeamName"
      :team-lists="teamLists"
      :date-data="dateData"
      @teamSelectFollow="handleTeamSelectFollow"
      @dateCallback="handleDateChange($event,1)"
    />
    <!-- 数据-列表 -->
    <div class="dev-data-statistic">
      <div
        class="level-select-div"
        @click="handleLevelSelect"
      >
        <span class="level-select-text">{{ infoTypeText }}</span><i class="iconfont iconicon-test18 level-icon" />
      </div>
      <div v-if="followFilterDataDetailList">
        <div
          v-for="(items,indexs) in followFilterDataDetailList"
          :key="indexs"
          class="detail-content"
        >
          <div v-if="dataType===1">
            <div
              v-if="items[0]<=2"
              class="circle"
            >
              {{ items[0] }}
            </div>
            <div
              v-else
              class="circle-gray"
            >
              {{ items[0] }}
            </div>
            <span class="text-content-ellipsis">{{ items[1] }}</span>
            <span class="number">{{ items[infoIndex] }}</span>
          </div>
          <div v-else>
            <span class="date-second-data">{{ items[0] }}</span>
            <!-- <span class="date-second-num">{{ items[1] }}</span> -->
            <span class="date-second-number">{{ items[checkIndexs] }}</span>
          </div>
        </div>
        <cube-loading v-if="!listDatas.length" />
      </div>
    </div>
    <LevelSelect
      :visible.sync="visible"
      type="follow"
      @levelSelect="handleLevelSelectChange"
    />
  </div>
</template>
<script>
import DateRange from './components/DateSelectComponents'
import { mapState, mapActions, mapMutations } from 'vuex'
import { overviewData, formatePickerData } from '@/lib/statistic-utils'
import LevelSelect from './components/LevelSelectComponents'
export default {
  components: {
    DateRange,
    LevelSelect
  },
  data () {
    return {
      foldStatus: false,
      visible: false,
      dateData: formatePickerData(overviewData),
      rowDirection: 'iconicon-test17',
      overviewTimeData: { timetype: 5 },
      detailTimeData: { timetype: 5 },
      listDatas: [],
      infoTypeText: this.$t('message["1353"]'),
      checkIndexs: null,
      dataType: null,
      infoIndex: 2,
      teamLists: [],
      defaultTeamName: ''
    }
  },
  computed: {
    ...mapState('statistic', ['followOverviewDatas', 'followTablesDetailDatas', 'formateRangeDatasStatus', 'followFilterDataDetailList']),
    rangeTitTxt () {
      return this.$t('message["288"]')
    },
    overviewTitTxt () {
      return this.$t('message["346"]')
    },
    dataTitTxt () {
      return this.$t('message["1130"]')
    }
  },
  watch: {
    followOverviewDatas (val) {
      if (!val) return
      this.listDatas = val
    },
    followTablesDetailDatas: {
      handler (val) {
        if (!val) return
        if (val.length <= 0) return
        if (val.config[1]) {
          if (val.config[1].options) {
            this.defaultTeamName = val.config[1].name
            const options = val.config[1].options
            const tempv = []
            for (const key in options) {
              tempv.push({ value: key, name: options[key][0] })
            }
            this.teamLists = tempv
          } else {
            this.teamLists = []
            this.defaultTeamName = ''
            if (!this.checkIndexs) {
              this.checkIndexs = 1
            }
          }
        }
        this.dataType = val.type
        if (this.dataType === 1) {
          this.setFollowFilterDataList(val.config.slice(2))
        } else {
          this.setFollowFilterDataList(val.config.slice(1))
        }
        this.setFollowFilterDataDetailList(val.data)
        document.title = this.$t('message["1364"]') + `-${this.$store.state.baseinfo.projectname}-${this.$store.state.baseinfo.comname}`
      },
      immediate: true
    }
  },
  mounted () {
    this.fetchGetMemberFollowRangeDatas()
    this.fetchGetFollowDataOverview(this.overviewTimeData)
    this.fetchGetFollowDetailTableDatas({ ...this.detailTimeData, page: 1 })
  },
  methods: {
    ...mapMutations('statistic', ['setFollowFilterDataList', 'setFollowFilterDataDetailList']),
    ...mapActions('statistic', ['fetchGetFollowDataOverview', 'fetchGetMemberFollowRangeDatas', 'fetchGetFollowDetailTableDatas']),
    handleDFold () {
      if (this.rowDirection === 'iconicon-test17') {
        this.foldStatus = true
        this.rowDirection = 'iconicon-test14'
      } else {
        this.foldStatus = false
        this.rowDirection = 'iconicon-test17'
      }
    },
    handleLevelSelect () {
      this.visible = true
    },
    handleTeamSelectFollow (value) {
      if (!value) return
      this.detailTimeData.groupType = value
      this.fetchGetFollowDetailTableDatas({ ...this.detailTimeData, page: 1 })
    },
    handleLevelSelectChange (value) {
      if (!value) return
      if (value.indexOf('-') >= 0) {
        const [name, index] = value.split('-')
        this.infoTypeText = name
        this.infoIndex = index
        this.checkIndexs = index * 1 - 1
      } else {
        this.levelText = this.$t('message["1353"]')
        this.infoIndex = 2
        this.checkIndexs = 1
      }
    },
    handleDateChange (value, flag) {
      if (flag === 0) {
        if (value.value === -1) {
          const { starttime, endtime } = value.time
          delete this.overviewTimeData.timetype
          this.overviewTimeData.starttime = starttime
          this.overviewTimeData.endtime = endtime
        } else {
          delete this.overviewTimeData.starttime
          delete this.overviewTimeData.endtime
          this.overviewTimeData.timetype = value.value
        }
        this.fetchGetFollowDataOverview(this.overviewTimeData)
      } else if (flag === 1) {
        if (value.value === -1) {
          const { starttime, endtime } = value.time
          delete this.detailTimeData.timetype
          this.detailTimeData.starttime = starttime
          this.detailTimeData.endtime = endtime
        } else {
          delete this.detailTimeData.starttime
          delete this.detailTimeData.endtime
          this.detailTimeData.timetype = value.value
        }
        this.fetchGetFollowDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
      }
    },
    handleCascaderSubmit (value) {
      const tempValue = value.value
      let json = {}
      if (Array.isArray(tempValue)) {
        tempValue.map(item => {
          json[item.keyname] = item.id
        })
      }
      delete this.detailTimeData.userid
      delete this.detailTimeData.groupid
      delete this.detailTimeData.roleid
      delete this.overviewTimeData.userid
      delete this.overviewTimeData.groupid
      delete this.overviewTimeData.roleid
      if (tempValue.length === 0) {
        this.fetchGetFollowDataOverview(this.overviewTimeData)
        this.fetchGetFollowDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
      } else {
        this.overviewTimeData = Object.assign(this.overviewTimeData, json)
        this.detailTimeData = Object.assign(this.detailTimeData, json)
        this.fetchGetFollowDataOverview(this.overviewTimeData)
        this.fetchGetFollowDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.large-text {
  width: 80px !important;
  overflow: hidden;
}
</style>
